
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

interface DeleteLeadsDialogProps {
  showDialog: boolean;
  setShowDialog: (show: boolean) => void;
  selectedLeadsCount: number;
  onConfirmDelete: () => void;
}

const DeleteLeadsDialog = ({
  showDialog,
  setShowDialog,
  selectedLeadsCount,
  onConfirmDelete,
}: DeleteLeadsDialogProps) => {
  return (
    <Dialog open={showDialog} onOpenChange={setShowDialog}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Delete Selected Leads</DialogTitle>
          <DialogDescription>
            Are you sure you want to delete {selectedLeadsCount} lead{selectedLeadsCount !== 1 ? 's' : ''}? This action cannot be undone.
          </DialogDescription>
        </DialogHeader>
        <DialogFooter>
          <Button variant="outline" onClick={() => setShowDialog(false)}>Cancel</Button>
          <Button variant="destructive" onClick={onConfirmDelete}>Delete</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteLeadsDialog;
